module.exports = __webpack_public_path__ + "media/images/game_icon/th/VG1001-6f7b5bdfbb657d3352a31d3ee3d642c3.png";